import { render, staticRenderFns } from "./PreviewExcel.vue?vue&type=template&id=c1451f56&scoped=true"
import script from "./PreviewExcel.vue?vue&type=script&lang=js"
export * from "./PreviewExcel.vue?vue&type=script&lang=js"
import style0 from "./PreviewExcel.vue?vue&type=style&index=0&id=c1451f56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1451f56",
  null
  
)

export default component.exports